module.exports = __webpack_public_path__ + "static/img/popupDownAppv.7a20c9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/popupDownAppv.png
// module id = 4Z0x
// module chunks = 1